import { t } from 'i18next'

/**
 * Form constants
 */
const START_DATETIME = 'start_datetime'

/**
 * Form model
 */
const formModel = () => {
  return {
    [START_DATETIME]: {
      label: `${t('common.lesson-start-time')}`,
      name: START_DATETIME,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [START_DATETIME]: null,

}

export default formModel
